<template>
  <div style="background-color: #F5F6FA; min-height: 100vh; padding-bottom: 2rem;">
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-container fluid class="px-4 py-0">
      <v-layout wrap justify-center pt-2>
        <v-flex xs12>
          <v-layout wrap justify-start>
            <v-flex
              v-for="(card, index) in cards"
              :key="index"
              xs12
              sm6
              md4
              lg3
              pa-3
            >
                            <v-card elevation="0" rounded="lg" :class="['stat-card', `card-idx-${index}`]">
                <div class="pa-5 d-flex align-center fill-height" style="background: transparent;">
                  <div :class="['icon-badge', `badge-idx-${index}`]" class="mr-4 flex-grow-0 flex-shrink-0">
                    <v-icon size="28" :class="[`icon-idx-${index}`]">{{ card.mdiIcon }}</v-icon>
                  </div>
                  <div class="d-flex flex-column justify-center text-start" style="min-width: 0; flex: 1; z-index: 2;">
                    <div class="card-title-container">
                      <span class="detailshead">{{ card.title }}</span>
                    </div>
                    <span class="value pt-1 pb-1">{{ card.value }}</span>
                    <div class="d-flex justify-start">
                      <span
                        class="action-link"
                        @click="redirectToPage(card.action, card.title)"
                      >
                        {{ card.action }}
                        <v-icon small class="action-icon ml-1">mdi-arrow-right</v-icon>
                      </span>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-start class="d-flex align-stretch">
        <v-flex xs12 lg7 pa-3 class="d-flex">
          <v-card elevation="0" class="chart-card card-cases d-flex flex-column justify-space-between fill-height pa-5" style="width: 100%;">
            <div style="width: 100%;">
              <v-layout wrap justify-start>
                <v-flex xs12 lg9>
                  <div class="d-flex align-center">
                    <v-icon color="#de520c" class="mr-2 mb-1" size="26">mdi-chart-timeline-variant</v-icon>
                    <span class="reportone">Total Cases Overview</span>
                  </div>
                </v-flex>
                <v-flex xs12 lg3>
                  <v-select
                    outlined
                    dense
                    rounded
                    color="#de520c"
                    :hide-details="true"
                    :items="yearitems"
                    v-model="lineyeardata"
                  ></v-select>
                </v-flex>
              </v-layout>
            </div>
            <div style="width: 100%;" class="pt-4 flex-grow-1 d-flex align-center">
              <div style="width: 100%;" v-if="flag1">
                <highcharts :options="histogramOptions" style="width: 100%;"></highcharts>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex xs12 lg5 pa-3 class="d-flex">
          <v-card elevation="0" class="chart-card card-species d-flex flex-column justify-space-between fill-height pa-5" style="width: 100%;">
            <div style="width: 100%;">
              <div class="d-flex align-center">
                <v-icon color="#eab308" class="mr-2 mb-1" size="26">mdi-chart-donut</v-icon>
                <span class="reportone">Top Common Snake Species</span>
              </div>
            </div>
            <div style="width: 100%;" class="pt-6 flex-grow-1 d-flex align-center">
              <div style="width: 100%;" v-if="flag">
                <highcharts
                  :options="highchartsOptions"
                  :constructor-type="'chart'"
                  style="width: 100%;"
                ></highcharts>
              </div>
            </div>
            <div style="width: 100%;" class="pt-6 text-center" v-if="flag">
              <span
                @click="redirectToSnakeDetails()"
                class="viewdetails-btn"
                >View All Species <v-icon small color="white" class="ml-1">mdi-arrow-right</v-icon></span
              >
            </div>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-start pt-4>
        <v-flex xs12 pa-3>
          <v-card elevation="0" class="chart-card card-leaderboard">
            <v-layout wrap justify-start pa-5>
              <v-flex xs12>
                <v-layout wrap justify-start>
                  <v-flex xs12 pa-3>
                    <span class="reportone"
                      >Top Rescuers of the Year {{ currentYear }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pt-4 pb-2>
                <v-layout wrap justify-start>
                  <v-flex
                    xs12
                    sm6
                    md4
                    lg3
                    v-for="(item, index) in topusers"
                    :key="item.name"
                    pa-2
                  >
                    <div :class="['leaderboard-card', `rank-${index + 1}`]">
                      <div class="rank-badge">
                        <span v-if="index < 3"><v-icon small color="white">mdi-trophy</v-icon></span>
                        <span v-else>#{{ index + 1 }}</span>
                      </div>
                      <div class="leaderboard-info" v-if="item && item.user && item.user.name">
                        <div class="rescuername">{{ item.user.name }}</div>
                        <div class="rescuervalue d-flex align-center mt-1">
                          <v-icon x-small color="#de520c" class="mr-1">mdi-snake</v-icon>
                          <span v-if="item.count">{{ item.count }} Rescues</span>
                          <span v-else>0 Rescues</span>
                        </div>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="topusers && topusers.length > 0">
                <v-layout wrap justify-end>
                  <v-flex xs12 pa-3 class="text-end">
                    <span
                      class="viewmore"
                      @click="redirectToUsersDetails()"
                      style="cursor: pointer"
                      >View More</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                align-self-start
                pl-4
                v-if="topusers && topusers.length === 0"
              >
                <span class="reporttwo">No data available!</span>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.toLocaleString("default", {
      month: "long",
    });
    const yearitems = Array.from({ length: 5 }, (_, i) => currentYear - 4 + i);
    return {
      currentYear,
      currentMonth,
      yearitems,
      lineyeardata: currentYear,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      pages: 0,
      count: 20,
      cards: [
        {
          title: "Total Users",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/totalusers.png"),
          mdiIcon: "mdi-account-group-outline",
          vert:require("@/assets/images/redvertical.png"),
          color: "green",
        },
        {
          title: "Snake Rescuers",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/icon_snake.png"),
          mdiIcon: "mdi-account-hard-hat",
          vert:require("@/assets/images/purplevert.png"),
          color: "blue",
        },
        {
          title: "Snakes Rescued",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/snakeresc.png"),
          mdiIcon: "mdi-hand-heart-outline",
          vert:require("@/assets/images/yellowvert.png"),
          color: "red",
        },
        {
          title: "Identification Help",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/idhelp.png"),
          mdiIcon: "mdi-help-circle-outline",
          vert:require("@/assets/images/bluevert.png"),
          color: "yellow",
        },
        {
          title: "Listed Hospitals",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/listhosp.png"),
          mdiIcon: "mdi-hospital-building",
          vert:require("@/assets/images/greenvert.png"),
          color: "red",
        },
        {
          title: "Snake Bite cases",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/snakedeath.png"),
          mdiIcon: "mdi-heart-pulse",
          vert:require("@/assets/images/greyvert.png"),
          color: "yellow",
        },
        {
          title: "Listed Snakes",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/listedsnakes.png"),
          mdiIcon: "mdi-snake",
          vert:require("@/assets/images/pinkvert.png"),
          color: "light-green",
        },
        {
          title: "Public users",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/publicusers.png"),
          mdiIcon: "mdi-account-network-outline",
          vert:require("@/assets/images/orangevert.png"),
          color: "purple",
        },
        {
          title: "Total Reports",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/dash1.png"),
          mdiIcon: "mdi-file-document-multiple-outline",
          vert: require("@/assets/images/bluevert.png"),
          color: "blue",
        },
        {
          title: "Completed Reports",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/dash2.png"),
          mdiIcon: "mdi-check-all",
          vert: require("@/assets/images/greenvert.png"),
          color: "green",
        },
        {
          title: "Snakes Escaped",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/dash4.png"),
          mdiIcon: "mdi-run-fast",
          vert: require("@/assets/images/greyvert.png"),
          color: "grey",
        },
      ],
      dates: [],
      details: [
        { title: "Most Common Snakes - 2024", icon: "mdi-snake" },
        { title: "Top Rescuers of July", icon: "mdi-snake" },
        { title: "Top Rescuers of 2024", icon: "mdi-snake" },
      ],
      topsnakes: [],
      topusers: [],
      options: {
        chart: {
          type: "donut",
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      series: [],
      flag: false,
      flag1: false,
      yearwiseData: [],
      histogramOptions: {
        chart: {
          type: "column",
          height: 400,
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [],
          title: {
            text: "Month",
            style: {
              color: "#64748b",
              fontFamily: "poppinsregular, sans-serif",
              fontSize: "14px",
            },
          },
          labels: {
            style: {
              color: "#64748b",
              fontFamily: "poppinsregular, sans-serif",
              fontSize: "13px",
            },
          },
          lineColor: "rgba(15, 23, 42, 0.08)",
          tickColor: "rgba(15, 23, 42, 0.08)",
        },
        credits: {
          enabled: false
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total Cases",
            style: {
              color: "#64748b",
              fontFamily: "poppinsregular, sans-serif",
              fontSize: "14px",
            },
          },
          labels: {
            style: {
              color: "#64748b",
              fontFamily: "poppinsregular, sans-serif",
              fontSize: "13px",
            },
          },
          gridLineColor: "rgba(15, 23, 42, 0.05)",
        },
        legend: {
          itemStyle: {
            color: "#0f172a",
            fontFamily: "poppinsregular, sans-serif",
            fontSize: "13px",
          },
          itemHoverStyle: {
            color: "#10b981",
          },
        },
        plotOptions: {
          column: {
            pointWidth: 30,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              style: {
                color: "#0f172a",
                textOutline: "none",
                fontFamily: "poppinsmedium, sans-serif",
                fontSize: "12px",
              },
            },
          },
        },
        series: [
          {
            name: "Reports",
            data: [],
            color: "#de520c",
          },
        ],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 600
            },
            chartOptions: {
              chart: {
                height: 300
              },
              xAxis: {
                labels: {
                  style: {
                    fontSize: "10px"
                  }
                }
              },
              yAxis: {
                labels: {
                  style: {
                    fontSize: "10px"
                  }
                }
              },
              plotOptions: {
                column: {
                  pointWidth: 15,
                  dataLabels: {
                    style: {
                      fontSize: "9px"
                    }
                  }
                }
              }
            }
          }]
        }
      },
      highchartsOptions: {
        chart: {
          type: "pie",
          height: 344,
          backgroundColor: "transparent",
        },
        colors: [
          "#de520c",
          "#3b82f6",
          "#facc15",
          "#ec4899",
          "#8b5cf6",
          "#06b6d4",
          "#f97316",
          "#ef4444",
          "#14b8a6",
          "#6366f1"
        ],
        credits: {
          enabled: false
        },
        title: {
          text: null,
          enabled: true,
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
          backgroundColor: "rgba(15, 23, 42, 0.95)",
          borderWidth: 1,
          borderColor: "rgba(255, 255, 255, 0.1)",
          style: {
            color: "#ffffff",
            fontFamily: "poppinsregular, sans-serif",
            fontSize: "13px",
          },
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            borderRadius: 6,
            borderWidth: 2,
            borderColor: "rgba(15, 23, 42, 0.08)",
            innerSize: "60%",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
              style: {
                color: "#0f172a",
                textOutline: "none",
                fontFamily: "poppinsmedium, sans-serif",
                fontSize: "13px",
              },
            },
          },
        },
        series: [
          {
            name: "Reports",
            colorByPoint: true,
            data: [],
          },
        ],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 600
            },
            chartOptions: {
              chart: {
                height: 300
              },
              plotOptions: {
                pie: {
                  dataLabels: {
                    style: {
                      fontSize: "9px"
                    }
                  }
                }
              }
            }
          }]
        }
      },
      seriesData: [],
    };
  },
  beforeMount() {
    this.countData();
    this.yearData();
    this.topsnakesData();
  },
  watch: {
    lineyeardata() {
      this.yearData();
    },
  },
  methods: {
    redirectToSnakeDetails() {
      this.$router.push({ path: "/dmotopcommonsnakes" });
    },
    topsnakesData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/topsnakes/all",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            const animalReportSummary = response.data.data.allSnakes.slice(0, 10);
            this.series = animalReportSummary.map((item) => item.totalReports);
            this.options.labels = animalReportSummary.map((item) => item.name);
            const seriesData = animalReportSummary.map((item) => ({
              name: item.snakeName,
              y: item.count,
            }));
            this.highchartsOptions.series[0].data = seriesData;
            this.flag = true;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    redirectToPage(action, title) {
      if (title === "Total Users") {
        this.$router.push({ path: "/dmousermap" });
      } else if (title === "Snake Rescuers") {
        this.$router.push({ path: "/dmorescuermap" });
      } else if (title === "Snakes Rescued") {
        this.$router.push({ path: "/dmosnakerescued" });
      } else if (title === "Identification Help") {
        this.$router.push({ path: "/dmoidentificationhelp" });
      } else if (title === "Listed Hospitals") {
        this.$router.push({ path: "/dmohospitalMap" });
      } else if (title === "Snake Bite Cases" || title === "Snake Bite cases") {
        this.$router.push({ path: "/dmosnakebiteDeath" });
      } else if (title === "Listed Snakes") {
        this.$router.push({ path: "/dmolistedSnakes" });
      } else if (title === "Public users") {
        this.$router.push({ path: "/dmousersList" });
      } else if (title === "Total Reports" || title === "Completed Reports" || title === "Snakes Escaped") {
        this.$router.push({ path: "/medicalOfficers/victimDetails" });
      }
    },

    redirectToUsersDetails() {
      this.$router.push({ path: "/dmotopUsers" });
    },
    redirectToUsersyearDetails() {
      this.$router.push({ path: "/topUsersyear" });
    },
    countData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/stats",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.cards[0].value = response.data.data.count_total_users;
              this.cards[1].value = response.data.data.count_total_rescuer;
              this.cards[2].value = response.data.data.count_total_locations;
              this.cards[3].value = response.data.data.count_identify;
              this.cards[4].value = response.data.data.count_hospital;
              this.cards[5].value = response.data.data.count_management;
              this.cards[6].value = response.data.data.count_snakes;
              this.cards[7].value = response.data.data.count_users;
              this.cards[8].value = response.data.data.count_total_reports || 0;
              this.cards[9].value = response.data.data.count_report_rescued || 0;
              this.cards[10].value = response.data.data.count_snake_escaped || 0;
              this.topsnakes = response.data.data.topsnakes;
              const topcommonsnakesSummary = response.data.data.topsnakes;
              this.series = topcommonsnakesSummary.map((item) => item.count);
              this.options.labels = topcommonsnakesSummary.map(
                (item) => item.snake.name
              );
              this.flag = true;
              this.topusers = response.data.data.topusers;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    yearData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/monthwise",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: this.lineyeardata,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.yearwiseData = response.data.data;
            this.histogramOptions.xAxis.categories = this.yearwiseData.map(
              (item) => item.month
            );
            this.histogramOptions.series[0].data = this.yearwiseData.map(
              (item) => item.count
            );
            this.flag1 = true;
            this.dates = response.data.data;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.detailshead {
  font-family: poppinsmedium, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #64748b;
}
.value {
  font-family: poppinsbold, sans-serif;
  font-size: 32px;
  font-weight: 800;
  line-height: 38px;
  letter-spacing: -0.5px;
  color: #0f172a;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
}
.listvalue {
  font-family: poppinsbold;
  font-size: 14px;
}
.sarpa {
  font-family: poppinsmedium;
  font-size: 20px;
  font-weight: 500;
}
.viewmore {
  font-family: poppinsmedium;
  font-size: 13px;
  color: #2563eb;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 600;
}
.viewmore:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
.reportone {
  font-family: poppinsbold, sans-serif;
  font-size: 19px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.3px;
  color: #0f172a;
}
.rescuername {
  font-family: poppinsmedium, sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}
.rescuervalue {
  font-family: poppinsmedium;
  font-size: 14px;
  font-weight: 600;
  color: #de520c;
}
.viewdetails-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #de520c, #b83e05);
  color: white !important;
  font-family: poppinsmedium, sans-serif;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 4px 12px rgba(222, 82, 12, 0.3);
}
.viewdetails-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(222, 82, 12, 0.45);
}

.reporttwo {
  font-family: poppinsmedium;
  font-weight: 500;
  font-size: 14px;
  color: #64748b;
}

/* Leaderboard Styling */
.leaderboard-card {
  display: flex;
  align-items: center;
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  padding: 12px 16px;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  height: 100%;
}

.leaderboard-card:hover {
  transform: translateY(-4px);
  background: rgba(15, 23, 42, 0.08);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
  border-color: rgba(222, 82, 12, 0.4);
}

.rank-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.08);
  color: rgba(15, 23, 42, 0.75);
  font-family: poppinsbold, sans-serif;
  font-size: 15px;
  margin-right: 16px;
  flex-shrink: 0;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.4s ease;
}

.leaderboard-card:hover .rank-badge {
  transform: scale(1.08);
}

.leaderboard-info {
  display: flex;
  flex-direction: column;
}

/* Premium Top 3 Styling */
.rank-1 {
  background: linear-gradient(135deg, rgba(250, 204, 21, 0.15), rgba(250, 204, 21, 0.05)) !important;
  border-color: rgba(250, 204, 21, 0.4) !important;
}
.rank-1 .rescuername {
  color: #854d0e !important;
}
.rank-1 .rank-badge {
  background: linear-gradient(135deg, #facc15, #ca8a04) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(250, 204, 21, 0.4) !important;
}
.rank-1:hover {
  border-color: #facc15 !important;
  box-shadow: 0 12px 25px rgba(250, 204, 21, 0.2) !important;
}

.rank-2 {
  background: linear-gradient(135deg, rgba(148, 163, 184, 0.15), rgba(148, 163, 184, 0.05)) !important;
  border-color: rgba(148, 163, 184, 0.4) !important;
}
.rank-2 .rescuername {
  color: #334155 !important;
}
.rank-2 .rank-badge {
  background: linear-gradient(135deg, #94a3b8, #64748b) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(148, 163, 184, 0.4) !important;
}
.rank-2:hover {
  border-color: #94a3b8 !important;
  box-shadow: 0 12px 25px rgba(148, 163, 184, 0.2) !important;
}

.rank-3 {
  background: linear-gradient(135deg, rgba(217, 119, 6, 0.15), rgba(217, 119, 6, 0.05)) !important;
  border-color: rgba(217, 119, 6, 0.4) !important;
}
.rank-3 .rescuername {
  color: #9a3412 !important;
}
.rank-3 .rank-badge {
  background: linear-gradient(135deg, #f59e0b, #b45309) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(217, 119, 6, 0.4) !important;
}
.rank-3:hover {
  border-color: #f59e0b !important;
  box-shadow: 0 12px 25px rgba(217, 119, 6, 0.2) !important;
}

/* Stat Card Base */
.stat-card {
  background-color: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.04) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02) !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.stat-card:hover {
  transform: translateY(-4px) !important;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08) !important;
}

/* Icon badge container */
.icon-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  z-index: 2;
  position: relative;
}

.stat-card:hover .icon-badge {
  transform: scale(1.05) !important;
}

/* Text Styling */
.stat-card .detailshead {
  color: #64748b !important;
  font-family: poppinsmedium, sans-serif !important;
  font-size: 11.5px !important;
  letter-spacing: 0.5px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.stat-card .value {
  color: #0f172a !important;
  font-family: poppinssemibold, sans-serif !important;
  font-size: 26px !important;
  font-weight: 700;
  line-height: 1.1;
}

/* Text Action Link */
.stat-card .action-link {
  display: inline-flex;
  align-items: center;
  color: #de520c !important;
  font-size: 13px !important;
  font-family: poppinsmedium, sans-serif !important;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease !important;
}
.stat-card .action-icon {
  color: #de520c !important;
  transition: all 0.2s ease !important;
}
.stat-card:hover .action-link {
  text-decoration: underline;
  color: #c2410c !important;
}
.stat-card:hover .action-icon {
  transform: translateX(4px);
  color: #c2410c !important;
}

/* Card Background Gradients */
.stat-card.card-idx-0 { background: #ffffff !important; border-color: #ffecd9 !important; }
.stat-card.card-idx-1 { background: #ffffff !important; border-color: #ffe6c8 !important; }
.stat-card.card-idx-2 { background: #ffffff !important; border-color: #fdd8d8 !important; }
.stat-card.card-idx-3 { background: #ffffff !important; border-color: #d1edfd !important; }
.stat-card.card-idx-4 { background: #ffffff !important; border-color: #ecd9ff !important; }
.stat-card.card-idx-5 { background: #ffffff !important; border-color: #ffe6c8 !important; }
.stat-card.card-idx-6 { background: #ffffff !important; border-color: #fbd6ea !important; }
.stat-card.card-idx-7 { background: #ffffff !important; border-color: #ffe6c8 !important; }
.stat-card.card-idx-8 { background: #ffffff !important; border-color: #d4dcff !important; }
.stat-card.card-idx-9 { background: #ffffff !important; border-color: #cdfadf !important; }
.stat-card.card-idx-10 { background: #ffffff !important; border-color: #fdd8d8 !important; }
.stat-card.card-idx-11 { background: #ffffff !important; border-color: #e6edf4 !important; }

/* Card Badge specific colors */
.badge-idx-0 { background: #ffeadd !important; }
.icon-idx-0 { color: #f46a2a !important; }

.badge-idx-1 { background: #ffebd6 !important; }
.icon-idx-1 { color: #f97316 !important; }

.badge-idx-2 { background: #fee2e2 !important; }
.icon-idx-2 { color: #ef4444 !important; }

.badge-idx-3 { background: #e0f2fe !important; }
.icon-idx-3 { color: #0ea5e9 !important; }

.badge-idx-4 { background: #f3e8ff !important; }
.icon-idx-4 { color: #a855f7 !important; }

.badge-idx-5 { background: #ffedd5 !important; }
.icon-idx-5 { color: #f97316 !important; }

.badge-idx-6 { background: #fce7f3 !important; }
.icon-idx-6 { color: #ec4899 !important; }

.badge-idx-7 { background: #ffedd5 !important; }
.icon-idx-7 { color: #f97316 !important; }

.badge-idx-8 { background: #e0e7ff !important; }
.icon-idx-8 { color: #6366f1 !important; }

.badge-idx-9 { background: #dcfce7 !important; }
.icon-idx-9 { color: #22c55e !important; }

.badge-idx-10 { background: #fee2e2 !important; }
.icon-idx-10 { color: #ef4444 !important; }

.badge-idx-11 { background: #f1f5f9 !important; }
.icon-idx-11 { color: #64748b !important; }


/* Chart and general container Cards */
.chart-card {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  border-radius: 16px !important;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(12px);
}

.chart-card.card-cases {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.chart-card.card-cases:hover {
  box-shadow: 0 25px 35px -5px rgba(15, 23, 42, 0.12), 0 15px 15px -5px rgba(15, 23, 42, 0.06) !important;
  border-color: rgba(222, 82, 12, 0.3) !important;
}

.chart-card.card-species {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.chart-card.card-species:hover {
  box-shadow: 0 25px 35px -5px rgba(15, 23, 42, 0.12), 0 15px 15px -5px rgba(15, 23, 42, 0.06) !important;
  border-color: rgba(222, 82, 12, 0.3) !important;
}

.chart-card.card-leaderboard {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.chart-card.card-leaderboard:hover {
  box-shadow: 0 25px 35px -5px rgba(15, 23, 42, 0.12), 0 15px 15px -5px rgba(15, 23, 42, 0.06) !important;
  border-color: rgba(222, 82, 12, 0.3) !important;
}

/* Sliding Shine on Chart Cards */
.chart-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.08) 25%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.08) 75%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: translateX(-110%) skewX(-20deg);
  transition: none;
  pointer-events: none;
}

.chart-card:hover::before {
  transform: translateX(110%) skewX(-20deg);
  transition: transform 1.6s cubic-bezier(0.16, 1, 0.3, 1);
}
</style>
